(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoLIService', ReporteEvaluativoLIService);

    ReporteEvaluativoLIService.$inject = ['$resource'];

    function ReporteEvaluativoLIService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteLI:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': { method:'POST' }
        });
    }
})();
